<lms-modal #modalStudentCreator>
  <lms-student-editor (saved)="onSave($event)">
    <a class="btn red" (click)="popupClose()" form-actions-before>{{ 'actions.cancel' | translate }}</a>
  </lms-student-editor>
</lms-modal>
